export default __webpack_public_path__ + "static/media/mark_mueller_modal.43ba6c15.jpg";